<template>
    <div class="achievements-page">
        <div class="page-head">
            <div class="left">
                <h1>Manage achievements</h1>
            </div>
        </div>
        <AchievementList ref="AchievementList"></AchievementList>
    </div>
</template>

<script>
    import AchievementList from "@/components/Achievements/AchievementList"
    export default {
        name: "Achievements",
        components: {
            AchievementList
        },

        methods: {

        },
        mounted() {}
    };
</script>
